import { ReactElement, forwardRef } from 'react';

import { IconButton as ButtonIcon, Tooltip } from '@material-ui/core';

import { useMuiDialogContext } from './context';

export type TriggerButtonIconProps = {
  icon: ReactElement;
  tooltip?: string;
  'aria-label': string;
  disabled?: boolean;
  className?: string;
};

export const TriggerButtonIcon = forwardRef<
  HTMLButtonElement,
  TriggerButtonIconProps
>((props, ref) => {
  const { icon, tooltip, disabled, ...rest } = props;
  const { onOpen, isLoading } = useMuiDialogContext();

  const button = (
    <ButtonIcon
      ref={ref}
      size="small"
      disabled={disabled || isLoading}
      onClick={onOpen}
      data-track-action="open-dialog"
      {...rest}
    >
      {icon}
    </ButtonIcon>
  );

  if (!tooltip) return button;

  return (
    <Tooltip title={tooltip} placement="left">
      {button}
    </Tooltip>
  );
});

TriggerButtonIcon.displayName = 'DialogComposite.TriggerButtonIcon';

export default TriggerButtonIcon;
